module.exports = __webpack_public_path__ + "static/img/Moderate_Rain.4539c28c.png";